export const PAGE_PATH = "ai-cover-letter"
